import React, { useEffect, useMemo } from 'react';
import { generatePath, Navigate, useParams } from 'react-router-dom';
import EditChannel from './EditChannel';
import { toast } from 'react-toastify';
import ROUTE from '../../../../constants/route-constants';
import { ChannelsTabs } from './ChannelsTabs';

const EditChannelWrapper: React.FC = () => {
  const { channel_number, id } = useParams();

  const isValidChannel = useMemo(() => {
    const channel = +channel_number;
    if (isNaN(channel)) {
      return false;
    }

    if (channel > 24 || channel < 1) {
      return false;
    }

    return true;
  }, [channel_number]);

  useEffect(() => {
    if (!isValidChannel) {
      toast.error(`Invalid channel number provided. Channel number: ${channel_number}`);
    }
  }, [isValidChannel]);

  if (!isValidChannel) {
    return <Navigate to={generatePath(ROUTE.EDIT_CONTROLLER, { id })} />;
  }

  return (
    <div>
      <ChannelsTabs activeChannel={+channel_number} controllerId={id} />
      <EditChannel />
    </div>
  );
};

export default EditChannelWrapper;
